<div
  class="object-search"
  [class.object-search--ch]="countries.indexOf('CH') > -1"
  [class.object-search--fr]="countries.indexOf('FR') > -1"
  [class.object-search--no-map]="!allowedToDisplayMap"
  [class.object-search--map-visible]="isMapVisible$ | async"
  [class.object-search--no-results]="(hasResults$ | async) === false"
  [class.object-search--scrolled-down]="scrolledState.scrolledDown"
  [class.object-search--at-scroll-top]="scrolledState.atScrollTop"
>
  <div class="object-search__main">
    <div class="object-search__filter">
      <div class="filter">
        <div class="filter__search">
          <div class="filter__search-box-wrapper">
            <app-mobile-filters></app-mobile-filters>
          </div>
        </div>

        <div class="filter__spacer" (click)="openMap()">
          <div class="filter__map-privacy-banner">
            <app-map-privacy-banner
              *ngIf="!allowedToDisplayMap"
            ></app-map-privacy-banner>
          </div>
        </div>

        <div class="filter__sticky-buttons">
          <app-sticky-buttons></app-sticky-buttons>
        </div>

        <div class="filter__desktop-filters">
          <div class="filter__rent-or-buy">
            <lib-contract-type-switch
              [options]="filterState.contractType.options"
              [currentOption]="filterState.contractType.filter"
              (update)="onContractTypeChange($event)"
            >
            </lib-contract-type-switch>
          </div>

          <div class="filter__filter-dropdowns">
            <app-desktop-filters></app-desktop-filters>
          </div>
        </div>
      </div>
    </div>

    <div class="object-search__list">
      <app-search-result-list
        *ngIf="
          (hasResults$ | async) === true || (isLoading$ | async) === true;
          else noResults
        "
      >
      </app-search-result-list>

      <ng-template #noResults>
        <app-no-results></app-no-results>
      </ng-template>
    </div>

    <div
      class="object-search__similar-objects-slider"
      *ngIf="(showSimilarObjects$ | async) === true"
    >
      <app-similar-objects-slider
        [isExpanded]="(hasResults$ | async) === false"
      ></app-similar-objects-slider>
    </div>
  </div>

  <div class="object-search__map-wrapper">
    <div class="object-search__map">
      <app-map *ngIf="allowedToDisplayMap"></app-map>

      <div
        class="object-search__map-privacy-message"
        *ngIf="!allowedToDisplayMap"
      >
        <div class="map-privacy">
          <div class="map-privacy__background">
            <div class="map-privacy__country-outline"></div>
          </div>

          <div class="map-privacy__banner">
            <app-map-privacy-banner></app-map-privacy-banner>
          </div>
        </div>
      </div>
    </div>

    <div class="object-search__map-cards">
      <app-map-cards></app-map-cards>
    </div>
  </div>

  <div class="object-search__mobile-map-toggle">
    <app-mobile-map-toggle></app-mobile-map-toggle>
  </div>
</div>
